import React, { useEffect, useState } from 'react';
import { getUsersAction } from '../../../modules/users/Actions';
import {
  usersSelector,
  usersIsLoadingSelector,
  usersCountSelector,
  searchValueSelector
} from '../../../modules/users/Selectors';
import { connect } from 'react-redux';
import List from '../../../components/Lists/List';
import ListItem from '../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserTypeContainer from './UserTypeContainer';
import { authCurrentDefaultTypeSelecetor } from '../../../modules/auth/Selectors';
import getLangData from '../../../utils/getLangData';
const SupplierTagsList = props => {
  const {
    users,
    usersIsLoading,
    getUsers,
    searchValue,
    usersCount,
    defaultUserType
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  useEffect(() => {
    if (defaultUserType === '1') {
      getUsers({
        size,
        offset,
        searchTerm: searchValue,
        filterOutUserType: ['0', '1', '7']
      });
    } else {
      getUsers({ size, offset, searchTerm: searchValue });
    }
  }, []);
  useEffect(() => {
    if (defaultUserType === '1') {
      getUsers({
        size,
        offset,
        searchTerm: searchValue,
        filterOutUserType: ['0', '1', '7']
      });
    } else {
      getUsers({ size, offset, searchTerm: searchValue });
    }
  }, [getUsers, searchValue, usersCount]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (users.length >= usersCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    if (defaultUserType === '1') {
      getUsers({
        size,
        offset: users.length,
        searchTerm: searchValue,
        filterOutUserType: ['0', '1', '7']
      });
    } else {
      getUsers({ size, offset: users.length, searchTerm: searchValue });
    }
    // getUsers({ size, , searchTerm: searchValue });
  };

  //
  const dataLength = users.length <= usersCount ? users.length : usersCount;
  // console.log(users);
  return (
    <InfiniteScroll
      dataLength={dataLength}
      hasMore={hasMore}
      next={fetchMore}
      style={{ overflow: 'hidden' }}
    >
      <div className='table row block--container my-5'>
        <List
          isLoading={usersIsLoading}
          header={{
            items: [
              getLangData().fields.name,
              getLangData().fields.email,
              getLangData().fields.user_type
            ],
            actions: ['Actions']
          }}
          items={users}
        >
          <table className='table'>
            <tbody>
              {users.map(
                ({ _id, firstName, lastName, email, userType, name }) => {
                  return (
                    <ListItem
                      type={'multi'}
                      name={`${firstName} ${lastName}`}
                      data={[
                        `${firstName} ${lastName}`,
                        email,
                        <UserTypeContainer userTypes={userType} key={_id} />
                      ]}
                      key={_id}
                      editLink={`/users/${_id}`}
                      onEnable={'hi'}
                      /* onDelete={() => deleteTag(_id)} */
                    />
                  );
                }
              )}
            </tbody>
          </table>
        </List>
      </div>
    </InfiniteScroll>
  );
};

const mapStateToProps = state => ({
  users: usersSelector(state),
  defaultUserType: authCurrentDefaultTypeSelecetor(state),
  usersIsLoading: usersIsLoadingSelector(state),
  usersCount: usersCountSelector(state),
  searchValue: searchValueSelector(state)
});

export default connect(mapStateToProps, {
  getUsers: getUsersAction
})(SupplierTagsList);
